export default __webpack_public_path__ + "assets/img_calculator_motorhome_expensive-4bdb2dea.jpg";